import Web3Service from '@/services/Web3Service'

export default abstract class MemeService {
    private abi = [{inputs:[{internalType:"string",name:"uri_",type:"string"}],stateMutability:"nonpayable",type:"constructor"},{anonymous:false,inputs:[{indexed:true,internalType:"address",name:"account",type:"address"},{indexed:true,internalType:"address",name:"operator",type:"address"},{indexed:false,internalType:"bool",name:"approved",type:"bool"}],name:"ApprovalForAll",type:"event"},{anonymous:false,inputs:[{indexed:false,internalType:"address",name:"userAddress",type:"address"},{indexed:false,internalType:"address payable",name:"relayerAddress",type:"address"},{indexed:false,internalType:"bytes",name:"functionSignature",type:"bytes"}],name:"MetaTransactionExecuted",type:"event"},{anonymous:false,inputs:[{indexed:true,internalType:"address",name:"operator",type:"address"},{indexed:true,internalType:"address",name:"from",type:"address"},{indexed:true,internalType:"address",name:"to",type:"address"},{indexed:false,internalType:"uint256[]",name:"ids",type:"uint256[]"},{indexed:false,internalType:"uint256[]",name:"values",type:"uint256[]"}],name:"TransferBatch",type:"event"},{anonymous:false,inputs:[{indexed:true,internalType:"address",name:"operator",type:"address"},{indexed:true,internalType:"address",name:"from",type:"address"},{indexed:true,internalType:"address",name:"to",type:"address"},{indexed:false,internalType:"uint256",name:"id",type:"uint256"},{indexed:false,internalType:"uint256",name:"value",type:"uint256"}],name:"TransferSingle",type:"event"},{anonymous:false,inputs:[{indexed:false,internalType:"string",name:"value",type:"string"},{indexed:true,internalType:"uint256",name:"id",type:"uint256"}],name:"URI",type:"event"},{inputs:[],name:"ERC712_VERSION",outputs:[{internalType:"string",name:"",type:"string"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"account",type:"address"},{internalType:"uint256",name:"id",type:"uint256"}],name:"balanceOf",outputs:[{internalType:"uint256",name:"",type:"uint256"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address[]",name:"accounts",type:"address[]"},{internalType:"uint256[]",name:"ids",type:"uint256[]"}],name:"balanceOfBatch",outputs:[{internalType:"uint256[]",name:"",type:"uint256[]"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"userAddress",type:"address"},{internalType:"bytes",name:"functionSignature",type:"bytes"},{internalType:"bytes32",name:"sigR",type:"bytes32"},{internalType:"bytes32",name:"sigS",type:"bytes32"},{internalType:"uint8",name:"sigV",type:"uint8"}],name:"executeMetaTransaction",outputs:[{internalType:"bytes",name:"",type:"bytes"}],stateMutability:"payable",type:"function"},{inputs:[],name:"getChainId",outputs:[{internalType:"uint256",name:"",type:"uint256"}],stateMutability:"pure",type:"function"},{inputs:[],name:"getDomainSeperator",outputs:[{internalType:"bytes32",name:"",type:"bytes32"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"user",type:"address"}],name:"getNonce",outputs:[{internalType:"uint256",name:"nonce",type:"uint256"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"account",type:"address"},{internalType:"address",name:"operator",type:"address"}],name:"isApprovedForAll",outputs:[{internalType:"bool",name:"",type:"bool"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"from",type:"address"},{internalType:"address",name:"to",type:"address"},{internalType:"uint256[]",name:"ids",type:"uint256[]"},{internalType:"uint256[]",name:"amounts",type:"uint256[]"},{internalType:"bytes",name:"data",type:"bytes"}],name:"safeBatchTransferFrom",outputs:[],stateMutability:"nonpayable",type:"function"},{inputs:[{internalType:"address",name:"from",type:"address"},{internalType:"address",name:"to",type:"address"},{internalType:"uint256",name:"id",type:"uint256"},{internalType:"uint256",name:"amount",type:"uint256"},{internalType:"bytes",name:"data",type:"bytes"}],name:"safeTransferFrom",outputs:[],stateMutability:"nonpayable",type:"function"},{inputs:[{internalType:"address",name:"operator",type:"address"},{internalType:"bool",name:"approved",type:"bool"}],name:"setApprovalForAll",outputs:[],stateMutability:"nonpayable",type:"function"},{inputs:[{internalType:"bytes4",name:"interfaceId",type:"bytes4"}],name:"supportsInterface",outputs:[{internalType:"bool",name:"",type:"bool"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"uint256",name:"",type:"uint256"}],name:"uri",outputs:[{internalType:"string",name:"",type:"string"}],stateMutability:"view",type:"function"},{inputs:[{internalType:"address",name:"account",type:"address"},{internalType:"uint256",name:"id",type:"uint256"},{internalType:"uint256",name:"amount",type:"uint256"}],name:"mint",outputs:[],stateMutability:"nonpayable",type:"function"}]

    public address: string;
    private web3Getter: () => Promise<any>;

    private models = ['145', '146', '147', '148'];

    constructor(address: string, web3Getter: () => Promise<any>) {
      this.address = address;
      this.web3Getter = web3Getter;
    }

    public async contract() {
        const web3 = await this.web3Getter();
        return new web3.eth.Contract(this.abi, this.address)
    }

    public async balanceOf(address: string, id: string) {
        return (await this.contract()).methods.balanceOf(address, id).call()
    }

    public async getApproved(tokenId: string) {
        return (await this.contract()).methods.getApproved(tokenId).call()
    }

    public async approve(address: string, tokenId: string) {
        const web3 = Web3Service.getInstance().getWeb3()
        const account = (await web3.eth.getAccounts())[0]
        return (await this.contract()).methods.approve(address, tokenId).send({ from: account })
    }

    public async tokensOf(account: string): Promise<{model: string, balance: string }[]> {
        const balances = [];
        for (let i = 0; i < this.models.length; i++) {
          const model = this.models[i];
          const balance = await this.balanceOf(account, model);
          balances.push({ model, balance });
        }
        return balances;
        /*
         * DOESNT WORK DUE TO RATE LIMIT ?
        const balances =  this.models.map(
          async model => ({ model, balance: await this.balanceOf(account, model) })
        );
        return Promise.all(balances);
        */
    }

    public async tokenURI(tokenId: number) {
        return (await this.contract()).methods.tokenURI(tokenId).call()
    }

    public async supply(model: number) {
        return (await this.contract()).methods.supply(model).call()
    }

    public async baseURI() {
        return (await this.contract()).methods.baseURI().call()
    }

    public async nextId(model: number) {
        return (await this.contract()).methods.nextId(model).call()
    }

    public async remaining(model: number) {
        const next = await this.nextId(model)
        const maxSupply = await this.supply(model)
        return maxSupply - next
    }

    public async isApprovedForAllOfConnected(operator: string)  {
        const web3 = Web3Service.getInstance().getWeb3()
        const account = (await web3.eth.getAccounts())[0]
        const contract = await this.contract();

        const result = await contract.methods.isApprovedForAll(account, operator).call();
        return result;
    }

    public async setApprovalForAll(operator: string, approved: boolean)  {
        const web3 = Web3Service.getInstance().getWeb3()
        const account = (await web3.eth.getAccounts())[0]
        const contract = await this.contract();

        return await contract.methods.setApprovalForAll(operator, approved).send({ from: account });
    }

    public async getTransfers(from: string, destination: string, fromBlock = ''): Promise<any[]> {
      if (fromBlock === '') {
        const web3 = await this.web3Getter();
        const currentBlock = await web3.eth.getBlockNumber();
        // 2 days before by default
        fromBlock = (currentBlock - (24*60*60*2)/3).toString();
      }
      const contract = await this.contract();
      return contract.getPastEvents("TransferBatch", {
        filter: {
          from,
          to: destination,
        },
        fromBlock,
        toBlock: 'latest',
      })
    }

    public async getBurns(from: string, fromBlock = ''): Promise<any[]> {
      if (fromBlock === '') {
        const web3 = await this.web3Getter();
        const currentBlock = await web3.eth.getBlockNumber();
        // 2 days before by default
        fromBlock = (currentBlock - (24*60*60*2)/3).toString();
      }
      const destination =  "0x0000000000000000000000000000000000000000";
      const contract = await this.contract();
      return contract.getPastEvents("TransferSingle", {
        filter: {
          from,
          to: destination,
        },
        fromBlock,
        toBlock: 'latest',
      })
    }
}
